import { render, staticRenderFns } from "./GraphicEditorDesktop.vue?vue&type=template&id=1c16377d"
import script from "./GraphicEditorDesktop.vue?vue&type=script&lang=js"
export * from "./GraphicEditorDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports